import * as React from 'react';
import { IDelprocess } from '../../../../Types/ProcessModel';

interface IProps {
  subprocess: IDelprocess;
}

/**
 * Inte implementerad ännu, uppdatera beskrivning när detta sker.
 */
class SubprocessPage extends React.PureComponent<IProps> {
  render() {
    return (
      // <Typography>
      //   {`${this.props.subprocess.Kod} ${this.props.subprocess.Benamning}`}
      // </Typography>
      <div />
    );
  }
}

export default SubprocessPage;
